import { render } from "./routes.vue?vue&type=template&id=b89ec4f0"
import script from "./routes.vue?vue&type=script&lang=js"
export * from "./routes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__